import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useData } from "../../contexts/DataContext";
import { fetchPricing } from "../../services/ApiService";
import styles from "./Pricing.module.css";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Price from "../../models/Price";

const Pricing: React.FC = () => {
  const { state, dispatch } = useData();
  const [openId, setOpenId] = useState<number | null>(null);

  useEffect(() => {
    if (!state.prices) fetchPricing(dispatch);
  }, [state.prices, dispatch]);

  const toggleDetails = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const prices = [...(state.prices ?? [])].sort((a, b) => {
    if (a.DisplayOrder !== b.DisplayOrder) {
      return a.DisplayOrder - b.DisplayOrder;
    }

    return a.id - b.id;
  });

  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        {prices.map((price: Price) => {
          const featured = price.id === prices[Math.floor(prices.length / 2)]?.id; // middle package
          return (
            <motion.article
              layout
              key={price.id}
              className={`${styles.card} ${featured ? styles.featured : ""}`}
              style={{ backgroundImage: `url(${state.baseApiPath + (price.Image?.url ?? "")})` }}
              whileHover={{ scale: 1.02 }}
            >
              <div className={styles.backdrop} />
              <div className={styles.content}>
                <h4 className={styles.packageTitle}>{price?.Title ?? "Package"}</h4>
                <div className={styles.priceRow}>
                  <div className={styles.price}>{price?.Price ? `$${price.Price}` : "TBD"}</div>
                  <button
                    className={styles.detailsBtn}
                    onClick={() => toggleDetails(price.id)}
                    aria-expanded={openId === price.id}
                  >
                    View Details
                  </button>
                </div>

                <AnimatePresence>
                  {openId === price.id && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      className={styles.details}
                    >
                      <div className={styles.description}>
                        {price?.Description ? (
                          // Prefer BlocksRenderer for rich content
                          typeof price.Description === "object" ? (
                            <BlocksRenderer content={price.Description} />
                          ) : (
                            <div dangerouslySetInnerHTML={{ __html: String(price.Description) }} />
                          )
                        ) : (
                          <p className={styles.small}>No details provided.</p>
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
};

export default Pricing;
